import { useMoodTrackingContext } from '../context/MoodTrackingContext';
export type { MoodTrackingState } from '../context/MoodTrackingContext';
export const useMoodTracking = () => {
  return useMoodTrackingContext();
};
export default useMoodTracking;